import { useQuery } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Fetches the authenticated user's staff record (id, role, regions, …). */
export function useGetAuthenticatedStaff() {
  const api = useOsApi()

  return useQuery({
    queryKey: ['staff', 'me'],
    queryFn: async () => {
      const response = await api.get('/staff/me')
      if (!response.success) throw new Error(response.error.message)
      return response.data.staff
    },
    staleTime: 5 * 60 * 1000,
  })
}
